import { computed, ref } from "vue";
import { useStore } from "@/core/services/store";
import _ from "lodash";
import { areasWithoutMigration } from "@/components/ExternalApps/SalesChannelManagementApp/utility/constants";

const store = useStore();
const initialized = ref(false);

export const useAppStatus = () => {
  function toggleStatus(status) {
    initialized.value = status;
  }

  const isAppInitialized = computed(() => initialized.value);

  const isProductsSelected = integration => {
    return (
      (store.getters["variables/configValueByName"]("productsSelected")
        ?.value?.[integration.id] ??
        false) ||
      !hasProductSelection.value
    );
  };

  const isMigrationFinished = _.memoize(function (integration) {
    return (
      (!integration?.migrationActive &&
        store.getters["variables/configValueByName"]("migrationChecks")
          ?.value?.[integration.id]?.migrationFinished !== false) ||
      !hasMigration.value
    ); // isMigrationFinished should always be true, if the current app doesn't support migrations
  });

  const hasMigration = computed(
    () => !store?.getters?.areaBlacklist?.includes("migration") ?? true
  );

  const hasProductSelection = computed(
    () => !store?.getters?.areaBlacklist?.includes("productSelection") ?? true
  );

  const hasJournal = computed(
    () => !store?.getters?.areaBlacklist?.includes("journal") ?? true
  );

  const hasOnlyMigration = computed(() =>
    areasWithoutMigration.every(el =>
      store.getters?.areaBlacklist?.includes(el)
    )
  );

  return {
    toggleStatus,
    isAppInitialized,
    isProductsSelected,
    isMigrationFinished,
    hasMigration,
    hasJournal,
    hasOnlyMigration
  };
};
